<template>
    <p style="color: #666666; font-size: 1rem">{{ borderosParaManipular.length }} pagamentos recusados</p>

    <div class="p-fluid formgrid grid">
        <div class="col-6 lg:col-4 xl:col-2">
            <label style="font-size: 0.94rem" for="dataInicioInput">Data de início (vencimento)</label>
            <Calendar name="dataInicioInput" id="dataInicioInput" placeholder="Selecione uma data" v-model="dataInicio" :showButtonBar="true" />
            <small class="p-error" v-if="dataFimDeveSerMaiorQueDataInicio">data final não pode ser menor que a inicial</small>
        </div>

        <div class="col-6 lg:col-4 xl:col-2">
            <label style="font-size: 0.94rem" for="dataFimInput">Data de fim (vencimento)</label>
            <Calendar placeholder="Selecione uma data" name="dataFimInput" id="dataFimInput" v-model="dataFim" :showButtonBar="true" />
            <small class="p-error" v-if="dataFimDeveSerMaiorQueDataInicio">data final não pode ser menor que a inicial</small>
        </div>
    </div>

    <div class="mt-3 p-fluid formgrid grid">
        <div v-for="bordero in dadosPaginados" v-bind:key="bordero?.borderoId" class="field col-12 md:col-6 lg:col-4">
            <BorderoCard :bordero="bordero"></BorderoCard>
        </div>
    </div>

    <h6 v-if="dadosPaginados.length <= 0">Nenhum borderô reprovado.</h6>

    <Paginator
        v-if="dadosPaginados.length > 0"
        :rows="elementosPorPagina"
        :totalRecords="0 || borderos?.length"
        :rowsPerPageOptions="[5, 10, 20, 50]"
        @update:first="atualizaPrimeiroElemento($event)"
        @update:rows="atualizaElementosPorPagina($event)"
        @page="atualizaPaginaAtual($event)"
    />
</template>

<script>
import BorderoCard from './BorderoCard.vue';

export default {
    components: {
        BorderoCard,
    },

    props: {
        borderos: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            elementosPorPagina: 5,
            paginaAtual: 0,
            primeiroElemento: 0,
            borderosParaManipular: [],
            dadosPaginados: [],
            dataInicio: null,
            dataFim: null,
        };
    },

    methods: {
        atualizaPrimeiroElemento(novoValor) {
            this.primeiroElemento = novoValor;
        },

        atualizaElementosPorPagina(elementosPorPagina) {
            this.elementosPorPagina = elementosPorPagina;
        },

        atualizaPaginaAtual(novaPagina) {
            this.paginaAtual = novaPagina;
            window.scrollTo(0, -100000);
        },

        paginaElementos(novoPrimeiroElemento = this.primeiroElemento, novoValorElementosPorPagina = this.elementosPorPagina) {
            const valorUltimoElementoListagem = novoPrimeiroElemento + novoValorElementosPorPagina - 1;

            if (valorUltimoElementoListagem >= this.borderosParaManipular.length) {
                this.dadosPaginados = this.borderosParaManipular.slice(novoPrimeiroElemento);
            }

            this.dadosPaginados = this.borderosParaManipular.slice(novoPrimeiroElemento, valorUltimoElementoListagem + 1);
        },

        filtrarPorData() {
            if (this.dataInicio && this.dataFim == null) {
                this.borderosParaManipular = this.borderos.filter((el) => new Date(el?.validade) >= new Date(this.dataInicio));
                return;
            }

            if (this.dataInicio == null && this.dataFim) {
                this.borderosParaManipular = this.borderos.filter((el) => new Date(el?.validade) <= new Date(this.dataFim));
                return;
            }

            if (this.dataInicio == null && this.dataFim == null) {
                this.borderosParaManipular = this.borderos;
                return;
            }

            this.borderosParaManipular = this.borderos.filter(
                (el) => new Date(el?.validade) <= new Date(this.dataFim) && new Date(el?.validade) >= new Date(this.dataInicio)
            );
        },
    },

    mounted() {
        this.filtrarPorData();
    },

    watch: {
        borderos(novoValor) {
            this.borderosParaManipular = novoValor;
        },

        primeiroElemento(novoPrimeiroElemento) {
            this.paginaElementos(novoPrimeiroElemento);
        },

        elementosPorPagina(novoValorElementosPorPagina) {
            this.paginaElementos(null, novoValorElementosPorPagina);
        },

        borderosParaManipular() {
            this.paginaElementos();
        },

        dataInicio() {
            this.filtrarPorData();
        },

        dataFim() {
            this.filtrarPorData();
        },
    },

    computed: {
        dataFimDeveSerMaiorQueDataInicio() {
            if (this.dataInicio == null || this.dataFim == null) {
                return false;
            }

            return new Date(this.dataFim) < new Date(this.dataInicio);
        },
    },
};
</script>

<style scoped>
.teste {
    background-color: none !important;
}
@media (min-width: 1024px) {
    .col-19w {
        width: 19%;
    }
}
</style>
